module.exports = __webpack_public_path__ + "static/media/link.2d2bc7ac.svg";